module.exports = __webpack_public_path__ + "media/images/flags/tk-54b9e3f941cb3083e2a3f71fe78e0c2d.svg";